// useTableModalState.js

import { useCallback, useState } from 'react';

const emptyModalState = {
    type: null,
    node: null,
    fieldDef: null,
    fieldKey: null,
};

const useTableModalState = () => {
    const [modalState, setModalState] = useState(emptyModalState);

    const handleModalClose = useCallback(() => {
        setModalState(emptyModalState);
    }, []);

    const handleModalOpen = useCallback((type, node, fieldDef, fieldKey) => {
        setModalState({ type, node, fieldDef, fieldKey });
    }, []);

    return {
        modalState,
        handleModalOpen,
        handleModalClose,
    };
};

export default useTableModalState;
